export default __webpack_public_path__ + "static/media/640x300_01.1b1ed5f0.jpg";